import {
    AUTH_REGION,
    AUTH_USER_POOL_ID,
    AUTH_USER_POOL_WEB_CLIENT_ID,
    AUTH_COOKIE_DOMAIN,
    AUTH_OAUTH_DOMAIN,
    AUTH_REDIRECT_SIGN_IN,
    AUTH_REDIRECT_SIGN_OUT,
    AUTH_USER_POOL_SECRET
} from './configs';


export const AwsConfigAuth = {
    Auth: {
        region: AUTH_REGION,
        userPoolId: AUTH_USER_POOL_ID,
        userPoolWebClientId: AUTH_USER_POOL_WEB_CLIENT_ID,
        clientSecret: AUTH_USER_POOL_SECRET, // Note the camelCase
        mandatorySignIn: false,
        cookieStorage: {
            domain: AUTH_COOKIE_DOMAIN,
            path: "/",
            expires: 365,
            sameSite: "strict",
            secure: false,
        },
        authenticationFlowType: "USER_PASSWORD_AUTH", // Changed from USER_SRP_AUTH
        oauth: {
            domain: AUTH_OAUTH_DOMAIN,
            scope: [
                "phone",
                "email",
                "profile",
                "openid",
                "aws.cognito.signin.user.admin",
            ],
            redirectSignIn: AUTH_REDIRECT_SIGN_IN,
            redirectSignOut: AUTH_REDIRECT_SIGN_OUT,
            responseType: "token",
        },
    },
};